<template>
	<div>
		<!-- 查询区域 -->
		<div class="table-page-search-wrapper">
			<div>
				<a-form layout="inline">
					<a-row :gutter="24">
						<!-- 数据类型 -->
						<a-col :md="6" :sm="6">
							<a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据类型">
								<a-radio-group name="dataType" v-model="reportType" @change="dataTypeChange">
									<a-radio value="11">小时数据</a-radio>
									<a-radio value="12">日数据</a-radio>
									<a-radio value="14">月数据</a-radio>
								</a-radio-group>
							</a-form-item>
						</a-col>

						<!-- 普通图表时间 -->
						<a-col :md="8" :sm="8">
							<a-form-item v-if="reportType == '11' || reportType == '12'" :labelCol="labelCol"
								:wrapperCol="wrapperCol" label="分析区间">
								<a-range-picker :allowClear="false" style="width: 300px" @change="onallChange" :value="value" />
							</a-form-item>
							<a-form-item v-else-if="reportType == '14'" :labelCol="labelCol" :wrapperCol="wrapperCol"
								label="分析区间">
								<a-range-picker :allowClear="false" :placeholder="['开始月份', '结束月份']" format="YYYY-MM" :value="value"
									:mode="['month', 'month']" @panelChange="onMonthRangeChange"
									@change="handleRangeChange" />
							</a-form-item>
						</a-col>
						<a-col :md="4" :sm="4">
							<a-button @click="searchChart" icon="search" type="primary" ghost>查询</a-button>
							<a-button @click="openCol" icon="menu-unfold" type="primary" ghost
								style="margin-left: 10px;"></a-button>
						</a-col>
					</a-row>
				</a-form>
			</div>
		</div>
		<col-control ref="colControl" :options="colOptions" @onChange="onChange"></col-control>
		<a-card :bordered="false">
			<div class="chart-box" :style="{ height: chartBoxHeight }">
				<water-more-chart ref="charts" @factorOption="value => { colOptions = value }" :reportType="reportType"
					:startTime="stime" :endTime="etime" :initNum="initNum"></water-more-chart>
			</div>
		</a-card>
	</div>
</template>

<script>
import {
	getAction
} from '@/api/manage'
import {
	GetSiteIdMixin
} from '@/mixins/GetSiteIdMixin'
import moment, {
	months
} from 'moment'
import waterMoreChart from '@/components/biChart/waterMoreChart'
import yearRange from '@/components/date/yearRange'
import weekRange from '@/components/date/weekRange'
import colControl from '@/components/colControl/colControl'

export default {
	name: 'lineAnalysis',
	mixins: [GetSiteIdMixin],
	components: {
		waterMoreChart,
		yearRange,
		weekRange,
		colControl
	},
	data() {
		return {
			colOptions: [],
			initNum: 0,
			reportType: '11',
			limitSelectDate: {},
			value: [],
			stime: '',
			etime: '',
			quantum: '',
			dateFormat: 'YYYY-MM-DD',
			chartBoxHeight: '604px',
			tableData: [],
			labelCol: {
				xs: {
					span: 24
				},
				sm: {
					span: 8
				},
			},
			wrapperCol: {
				xs: {
					span: 24
				},
				sm: {
					span: 16
				},
			},
			powerList: [],
		}
	},
	created() {
		this.limitSelectDate = {
			min: moment().startOf('day').subtract(1, 'week'),
			max: moment().endOf('day'),
		}
		this.value[0] = this.limitSelectDate.min
		this.value[1] = this.limitSelectDate.max
		this.stime = this.limitSelectDate.min.format('YYYY-MM-DD')
		this.etime = this.limitSelectDate.max.format('YYYY-MM-DD')



	},
	mounted() {
		setTimeout(() => {
			this.$bus.$emit('isCheckbox', 'show', true)
			if (!window.localStorage.getItem('treeSt')) {
				this.$bus.$emit('st', '')
			}
		}, 200)
	},
	beforeDestroy() {
		this.$bus.$emit('isCheckbox', 'show', false)
	},
	methods: {
		onChange() {
			let selectedtargetList = JSON.parse(JSON.stringify(this.$refs.charts.typeOptionsSource))
			let arr = []
			this.$refs.colControl.selectCol.forEach(item => {
				selectedtargetList.forEach((item1, index1) => {
					if (item == item1.value) {
						arr.push(item1)
					}
				})
			})
			this.$refs.charts.typeOptions = arr
			this.$refs.charts.factorCode = this.$refs.charts.typeOptions[0].value
			this.$refs.charts.changeCode()
		},
		openCol(index) {
			if (typeof index == 'number') {
				this.$refs.colControl[0].visible = true
			} else {
				this.$refs.colControl.visible = true
			}
		},
		moment,
		searchChart() {
			this.initNum++
		},
		onMonthRangeChange(value) {
			this.value = value
			this.stime = moment(value[0]).format('YYYY-MM')
			this.etime = moment(value[1]).format('YYYY-MM')
		},
		handleRangeChange(date, dateString) {
			this.stime = dateString[0]
			this.etime = dateString[1]
			// this.value = dateString
			// console.log('实时数据/日数据', dateString)
		},

		dataTypeChange(e) {
			this.reportType = e.target.value
			if (e.target.value == '14') {
				this.limitSelectDate = {
					min: moment().startOf('day').subtract(1, 'month'),
					max: moment().endOf('day'),
				}
				this.value[0] = this.limitSelectDate.min
				this.value[1] = this.limitSelectDate.max
				this.stime = this.limitSelectDate.min.format('YYYY-MM')
				this.etime = this.limitSelectDate.max.format('YYYY-MM')
			} else if (e.target.value == '11' || e.target.value == '12') {
				this.value[0] = this.limitSelectDate.min
				this.value[1] = this.limitSelectDate.max
				this.stime = this.limitSelectDate.min.format('YYYY-MM-DD')
				this.etime = this.limitSelectDate.max.format('YYYY-MM-DD')
			}
		},

		onallChange: function (date, dateString) {
			this.stime = dateString[0]
			this.etime = dateString[1]
			this.value = date
		},
	},
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.table-page-search-wrapper {
	margin-bottom: 10px;
}

.table-page-search-wrapper>>>.ant-card-wider-padding .ant-card-body {
	padding: 24px 32px 0;
}
</style>
